import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { ModuleTypes } from "@/store/ModuleTypes";
import {
  archiveTeam,
  getCreateTeamSubscriptionInfo,
  getPlayersByTeam,
  getTeam,
  purchaseLicense,
  unarchiveTeam
} from "@/helpers/api";
import router from "@/router";
import { bus } from "@/main";

@Module({ namespaced: true, name: ModuleTypes.TEAMS })
export default class TeamsModule extends VuexModule {
  loading = true;
  showTeamsOfTypeFilter = "active";
  filter = "";
  organizationSelected = false;
  venueErrors = 0;

  team = {} as any;
  org = {} as any;

  teamTagMatch = { value: false } as any;

  error = null;
  playersByTeam = [];

  expandedTeams = [];

  isShowAdmins = false;
  teamDetails = null as any;

  playerIframeIdString = "";

  showLicenseDialog = false;
  subInfo = {} as any;
  unarchivePending = null as any;

  get isTeamExpanded() {
    return (team: any) => {
      return this.expandedTeams.findIndex((t: any) => t.id === team.id) !== -1;
    };
  }

  get isTeamSelected() {
    return (team: any) => {
      return this.team.id === team.id;
    };
  }

  get filterValue() {
    return this.filter;
  }

  get playerIframeId() {
    return this.playerIframeIdString;
  }

  get subDetails() {
    return this.subInfo;
  }

  get showAdmins() {
    return this.isShowAdmins;
  }

  get totalVenueErrors() {
    return this.venueErrors;
  }

  get showTeamsOfType() {
    return this.showTeamsOfTypeFilter;
  }

  get selectedOrg() {
    return this.org;
  }

  get selectedTeam() {
    return this.teamDetails;
  }

  get selectedTeamId() {
    return this.teamDetails ? this.teamDetails.id : null;
  }

  get isOrganizationSelected() {
    return this.organizationSelected;
  }

  get isLoading() {
    return this.loading;
  }

  get playersByTeamArray() {
    return this.playersByTeam.map((t: any) => this.filterTeam(t, this.filter));
  }

  get playersByArchivedTeamArray() {
    return this.playersByTeam.map((t: any) => t.dateArchived);
  }

  get licenseDialog() {
    return this.showLicenseDialog;
  }

  get organization() {
    return this.teamDetails && this.teamDetails.organization
      ? this.teamDetails.organization
      : this.teamDetails;
  }

  get licensesAvailable() {
    return this.subInfo && this.subInfo.licensesRemaining
      ? this.subInfo.licensesRemaining.licensesRemaining
      : null;
  }

  get unassignedTeam(): any {
    return {
      archived: false,
      id: null,
      isOrganization: false,
      isRosterVisible: false,
      links: [],
      name: "No Team Assigned",
      orgAdmins: [],
      organization: this.organization,
      players: this.unassignedPlayers,
      type: "Team"
    };
  }

  get unassignedPlayers() {
    const playerList: any = this.organization.players || [];

    let teamPlayerList: any = [];

    this.organization.teams.forEach((team: any) => {
      if (team.players) {
        teamPlayerList = teamPlayerList.concat(team.players);
      }
    });

    return playerList.filter(
      (el: any) => !teamPlayerList.find((el2: any) => el.id === el2.id)
    );
  }

  get isOrg() {
    return this.teamDetails && this.teamDetails.isOrganization;
  }

  get filteredTeams() {
    if (!this.teamDetails) {
      return [];
    } else if (!this.teamDetails.organization) {
      let teams;
      if (!this.teamDetails.teams || this.teamDetails.teams.length === 0) {
        teams = [this.teamDetails];
      } else {
        const teamsCopy = this.teamDetails.teams.map((t: any) => ({ ...t }));
        teams = teamsCopy.filter((team: any) => {
          console.log(this.showTeamsOfType + " === " + team.tag);
          return this.showTeamsOfType === "active"
            ? !team.archived
            : this.showTeamsOfType === "archived"
            ? team.archived
            : true;
        });
        const teamsByTag: any = [];
        if (this.filter.length > 0) {
          let exactMatch = false;
          teams.forEach((team: any) => {
            let match = false;
            team.tag.forEach((t: any) => {
              if (
                t.name.toLowerCase() === this.filter.toLowerCase() &&
                !match
              ) {
                team.organizationId = team.isOrganization
                  ? team.id
                  : this.teamDetails
                  ? this.teamDetails.isOrganization
                    ? this.teamDetails.id
                    : this.teamDetails.organization.id
                  : null;
                this.teamTagMatch.value = true;
                teamsByTag.push(team);
                match = true;
                exactMatch = true;
              }
            });
          });
          if (!exactMatch) {
            teams.forEach((team: any) => {
              let match = false;
              team.tag.forEach((t: any) => {
                if (
                  t.name.toLowerCase().includes(this.filter.toLowerCase()) &&
                  !match
                ) {
                  team.organizationId = team.isOrganization
                    ? team.id
                    : this.teamDetails
                    ? this.teamDetails.isOrganization
                      ? this.teamDetails.id
                      : this.teamDetails.organization.id
                    : null;
                  this.teamTagMatch.value = true;
                  teamsByTag.push(team);
                  match = true;
                }
              });
            });
          }
        }
        if (teamsByTag.length > 0) {
          return teamsByTag;
        } else {
          this.teamTagMatch.value = false;
        }
      }

      teams = teams.sort((a: any, b: any) => (a.name < b.name ? -1 : 1));
      teams.push(this.unassignedTeam);

      teams = teams.map((t: any) => this.filterTeam(t, this.filter));
      return teams;
    } else {
      return [this.filterTeam(this.teamDetails, this.filter)];
    }
  }
  get playerCount() {
    return this.organization && this.organization.players
      ? this.organization.players.length
      : 0;
  }
  get organizationActiveTeamCount() {
    return this.organization.isOrganization
      ? this.organization.teams.filter((team: any) => !team.archived).length
      : 0;
  }

  get filterTeam() {
    return (t: any, filter: string) => {
      const val = { ...t };

      val.organizationId = val.isOrganization
        ? val.id
        : this.teamDetails
        ? this.teamDetails.isOrganization
          ? this.teamDetails.id
          : this.teamDetails.organization.id
        : null;

      if (!this.teamTagMatch.value) {
        val.players = val.players.filter((p: any) =>
          `${p.firstName} ${p.lastName}`
            .toLowerCase()
            .includes(filter.toLowerCase())
        );
      }
      if (val.myPlayers) {
        val.myPlayers = val.myPlayers.filter((p: any) =>
          `${p.firstName} ${p.lastName}`
            .toLowerCase()
            .includes(filter.toLowerCase())
        );
      }
      if (val.orgAdmins) {
        val.orgAdmins = val.orgAdmins.filter((p: any) =>
          p.name.toLowerCase().includes(filter.toLowerCase())
        );
      }

      return val;
    };
  }

  get hasPermission() {
    const user = this.context.rootState.user;
    return (filteredTeam: any, permission: string) => {
      const admin = filteredTeam.orgAdmins.find(
        (admin: any) => admin.id === user.id
      );
      if (admin && admin.permissions[permission]) {
        return true;
      }
      if (this.teamDetails && this.teamDetails.orgAdmins) {
        const orgAdmin = this.teamDetails.orgAdmins.find(
          (admin: any) => admin.id === user.id
        );
        if (orgAdmin && orgAdmin.permissions[permission]) {
          return true;
        }
      }

      if (
        this.teamDetails &&
        this.teamDetails.organization &&
        this.teamDetails.organization.orgAdmins
      ) {
        const orgAdmin = this.teamDetails.organization.orgAdmins.find(
          (admin: any) => admin.id === user.id
        );
        if (orgAdmin && orgAdmin.permissions[permission]) {
          return true;
        }
      }
    };
  }

  get orgLinks() {
    return (filteredTeam: any) => {
      const links = [];
      // if (
      //   !filteredTeam.isOrganization &&
      //   this.hasPermission(filteredTeam, "canArchiveTeams")
      // ) {
      //   links.push({
      //     text: filteredTeam.archived ? "Unarchive" : "Archive",
      //     id: "archive",
      //     callback: () => this.toggleArchive(filteredTeam)
      //   });
      // }

      if (this.hasPermission(filteredTeam, "canEditTeam")) {
        links.push({
          text: "Settings",
          callback: () => {
            bus.$emit("loadIframe", {
              url: `/settings/${filteredTeam.id}/settings`,
              title: filteredTeam.name
            });
          },
          id: "settings"
        });
      }

      if (this.hasPermission(filteredTeam, "canEditAdministrators")) {
        links.push({
          text: "Administrators",
          callback: () => {
            bus.$emit("loadIframe", {
              url: `/settings/${filteredTeam.id}/administrators`,
              // url: `/administrators/${filteredTeam.id}?hideNav=true`,
              title: filteredTeam.name
            });
          },
          id: "administrators"
        });
      }

      links.push({
        text: "Export Players",
        href: `/o/${filteredTeam.id}/exportPlayers#quick`,
        id: "export-players"
      });

      links.push({
        text: "Online Registration",
        callback: () => {
          bus.$emit("loadIframe", {
            url: `/settings/${filteredTeam.id}/registration`,
            title: filteredTeam.name
          });
        },
        id: "online-registration"
      });

      links.push({
        text: "Waivers & Agreements",
        callback: () => {
          bus.$emit("loadIframe", {
            url: `/agreements/${filteredTeam.id}`,
            title: filteredTeam.name
          });
        },
        id: "agreements"
      });

      links.push({
        text: "Links",
        callback: () => {
          bus.$emit("loadIframe", {
            url: `/links/${filteredTeam.id}`,
            title: filteredTeam.name
          });
        },
        id: "links"
      });

      if (
        filteredTeam.isOrganization &&
        this.hasPermission(filteredTeam, "canEditBillingInfo")
      ) {
        links.push({
          text: "Billing",
          callback: () => {
            bus.$emit("loadIframe", {
              url: "/settings/" + filteredTeam.id + "/billing",
              title: filteredTeam.name
            });
          },
          id: "billing"
        });
      }

      return links;
    };
  }

  @Mutation
  expandTeam(team: any) {
    this.expandedTeams = [...this.expandedTeams, team] as any;
  }
  @Mutation
  collapseTeam(team: any) {
    const index = this.expandedTeams.findIndex((t: any) => t.id === team.id);
    this.expandedTeams.splice(index, 1);
  }

  @Mutation
  setPlayerIframeIdString(id: string) {
    this.playerIframeIdString = id;
  }

  @Mutation
  setTeamDetails(data: any) {
    this.teamDetails = data;
  }

  @Mutation
  toggleShowAdmins() {
    this.isShowAdmins = !this.isShowAdmins;
  }

  @Mutation
  setTeam(team: any) {
    this.team = team;
  }

  @Mutation
  setOrganization(org: any) {
    this.org = org;
  }

  @Mutation
  setFilterVal(e: string) {
    this.filter = e;
  }

  @Mutation
  setIsOrganizationSelected(bool: boolean) {
    this.organizationSelected = bool;
  }

  @Mutation
  toggleLoading() {
    this.loading = !this.loading;
  }

  @Mutation
  setLoading(bool: boolean) {
    this.loading = bool;
  }

  @Mutation
  setSubInfo(data: any) {
    this.subInfo = data;
  }

  @Mutation
  setPlayersByTeam(data: any) {
    this.playersByTeam = data;
  }

  @Mutation
  setShowTeamsOfType(val: string) {
    this.showTeamsOfTypeFilter = val;
    router.push({
      name: "Team",
      params: {
        id: this.teamDetails.id,
        type: this.organizationSelected ? this.showTeamsOfTypeFilter : null
      }
    } as any);
  }

  @Mutation
  setVenueErrors(errors: number) {
    this.venueErrors = errors;
  }

  @Mutation
  viewPlayer({ team, player }: any) {
    this.playerIframeIdString = player.id;
    const url =
      "/dashboard/player/" + player.id + "?o=" + team.id + "&hideNav=true";
    const callback = () => {
      bus.$emit("refetchTeam");
    };
    bus.$emit("loadIframe", {
      title: "Player Profile",
      url: url,
      callback: callback
    });
  }

  @Mutation
  viewMyPlayer({ team, player }: any) {
    this.playerIframeIdString = player.id;
    const url =
      "/dashboard/player/" + player.id + "?o=" + team.id + "&hideNav=true";
    const callback = () => {
      bus.$emit("refetchPlayer");
    };
    bus.$emit("loadIframe", {
      title: "Player Profile",
      url: url,
      callback: callback
    });
  }

  @Mutation
  openImportPlayersIframe(id: string) {
    const url = `/o/${id}/addPlayers?hideNav=true#spreadsheet`;
    bus.$emit("loadIframe", {
      title: "Import Players From Spreadsheet",
      url: url
    });
  }

  @Mutation
  openAddPlayersQuickIframe(id: string) {
    const url = `/o/${id}/addPlayers?hideNav=true#quick`;
    bus.$emit("loadIframe", {
      title: "Add Players",
      url: url,
      callback: () => {
        window.location.reload();
      }
    });
  }

  @Mutation
  setShowLicenseDialog(bool: boolean) {
    this.showLicenseDialog = bool;
  }

  @Mutation
  setUnarchivePending(team: any) {
    this.unarchivePending = team;
  }

  @Action
  redirectToVenues() {
    bus.$emit("loadIframe", {
      url: `/venues/${this.organization.id}?hideNav=true&hideSide=true`,
      title: "Venues"
    });
  }

  @Action
  redirectToEmailPlayer({ team, player }: any) {
    const url =
      "/email-team/" +
      team.id +
      "?playerId=" +
      player.id +
      "&hideNav=true&cancelUrl=";
    bus.$emit("loadIframe", { title: "Email", url: url });
  }

  @Action
  redirectToEmailTeam(id: string) {
    const url = "/email-team/" + id + "?hideNav=true&cancelUrl=";
    bus.$emit("loadIframe", { title: "Email", url: url });
  }

  @Mutation
  redirectToChatWithOrgAdmins(filteredTeam: any) {
    // context.state.chat.newDmOrgId = filteredTeam.id;
    // console.log(this.context.rootState.chat.newDmOrgId)
    window.location.href = `/chat?orgId=${
      filteredTeam.organization ? filteredTeam.organization.id : filteredTeam.id
    }&userId=${filteredTeam.orgAdmins.map((oa: any) => oa.id).join(";")}`;
  }

  @Action
  redirectToChat({ teamId, playerId }: any) {
    window.location.href = `/chat?orgId=${teamId}&playerId=${playerId}`;
  }

  @Action
  async requestPlayersByTeam() {
    this.setLoading(true);
    const data = await getPlayersByTeam();
    this.setLoading(false);
    this.setPlayersByTeam(data);
  }

  @Action
  async requestTeamDetailsAsync(id: string) {
    getTeam(id).then(data => {
      this.setTeamDetails(data);
    });
  }

  @Action
  async toggleArchive(team: any) {
    bus.$emit("loadingOn", "Loading...");
    try {
      let resp;
      if (team.archived) {
        const orgId = team.organizationId || team.id;
        const data = await getCreateTeamSubscriptionInfo(orgId, null, 1);
        this.setSubInfo(data);
        if (this.subInfo.licensesRemaining.licensesRemaining > 0) {
          resp = await unarchiveTeam(team.id);
        } else {
          this.setShowLicenseDialog(true);
          this.setUnarchivePending(team);
          bus.$emit("loadingOff");
          return;
        }
      } else {
        resp = await archiveTeam(team.id);
      }

      if (resp.data.success) {
        bus.$emit(
          "successSnack",
          "Successfully " + (team.archived ? "un" : "") + "archived team"
        );
        team.archived = !team.archived;
        bus.$emit("refetchTeam");
      } else {
        bus.$emit("errorSnack", resp.data.message);
      }
      bus.$emit("loadingOff");
    } catch (e) {
      console.error(e);
    }
  }

  @Action
  async purchaseLicenseAndUnarchive(subscriptionId: string) {
    bus.$emit("loadingOn", "Adding New Team License");
    const updatedSub = await purchaseLicense(this.team.id, subscriptionId, 1);
    bus.$emit("loadingOff");
    if (!updatedSub) {
      bus.$emit("errorSnack", "Unable to add license");
    } else {
      this.setShowLicenseDialog(false);
      await this.toggleArchive(this.unarchivePending);
    }
  }
  @Mutation
  updateTagsOnTeam({ team }: any) {
    if (this.teamDetails.id === team.id) {
      this.teamDetails.tag = team.tag;
    } else {
      this.teamDetails.teams.forEach((i: any) => {
        if (team.id === i.id) {
          i.tag = team.tag;
        }
      });
    }
  }
}
